import { inject } from '@angular/core/primitives/di';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(Auth);

  // If already authenticated in this session, skip the HTTP round-trip
  // to avoid a redundant 401 → Keycloak redirect on every navigation.
  if (authService.isLoggedIn()) {
    return true;
  }

  return authService.checkAuth().pipe(
    map(() => true)
  );
};
